import React from "react";
import { useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
} from "react-native";
import { apiservice } from "../../service/api";
import { useRecoilState, useSetRecoilState } from "recoil";
import { tokenState, userState } from "../../reducer";

const { width, height } = Dimensions.get("window");

export default function App({ navigation, route }) {
  const [username, setUsername] = useState("");
  const setToken = useSetRecoilState(tokenState);
  const setUser = useSetRecoilState(userState);
  const [validate, setValidate] = useState(false);
  const [password, setpassword] = useState("");

  async function loginFlow() {
    const res = await apiservice({
      path: "/authen/loginadmin",
      method: "post",
      body: {
        username,
        password,
      },
    });
    if (res.status == 200) {
      setValidate(false);
      setToken(res.data);

      const res_user = await apiservice({
        path: "/authen/getuseradmin",
        method: "get",
        token: res.data.accessToken,
      });

      setUser(res_user.data.result);
      res.data.role == "ADMIN"
        ? navigation.navigate("HomeAdmin", res_user.data)
        : navigation.navigate("HomeSuperAdmin", res_user.data);

      return
    }

    setValidate(true);
  }

  return (
    <View style={styles.container}>
      <View
        style={{
          width: width,
          height: height,
          backgroundColor: "#002377",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: width * 0.13,
            height: height * 0.231,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            resizeMode={"contain"}
            style={{ width: width * 0.12, height: height * 0.22 }}
            source={require("../../img/Logo.png")}
          />
        </View>
        <Text style={styles.Text20}>ชื่อผู้ใช้งาน</Text>
        <TextInput
          defaultValue={username}
          onChangeText={setUsername}
          style={[
            styles.TextBox,
            { borderColor: "#ff0000", borderWidth: validate ? 1 : 0 },
          ]}
        />
        <Text style={styles.Text20}>รหัสผ่าน</Text>
        <TextInput
          secureTextEntry
          defaultValue={password}
          onChangeText={setpassword}
          style={[
            styles.TextBox,
            { borderColor: "#ff0000", borderWidth: validate ? 1 : 0 },
          ]}
        />
        {validate && (
          <Text style={[styles.Text20, { color: "#ff0000" }]}>
            รหัสผ่านไม่ถูกต้อง
          </Text>
        )}

        <TouchableOpacity onPress={loginFlow} style={styles.BoxLogin}>
          <Text style={styles.TextBoxLogin}>เข้าสู่ระบบ</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
  },
  Text20: {
    fontSize: 16,
    color: "#ffff",
    width: width * 0.234,
    marginVertical: 10,
  },
  TextBox: {
    width: width * 0.234,
    height: height * 0.055,
    backgroundColor: "#ffff",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 16,
    fontFamily: "Prompt-Regular",
  },
  TextBoxLogin: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#3363D5",
  },
  BoxLogin: {
    width: width * 0.093,
    height: height * 0.046,
    backgroundColor: "#ffff",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 30,
    borderRadius: 5,
  },
});
